export default __webpack_public_path__ + "static/m-feature-3-8f0ca38d05228bba207f5a8a87949808.png";